<template>
  <div class="filtro-container">
    <input
      class="input"
      type="text"
      v-model="busqueda"
      placeholder="Buscar cliente"
      @keypress.enter="searchClient"
    />
    <div class="select-container">
      <label class="select-title">Filtro de fecha</label>
      <select @change="handleDateSelect" class="select">
        <option
          v-for="(s, i) in dateSelect"
          :key="i"
          :value="s.value"
          :selected="s.selected"
          :disabled="s.disabled"
        >
          {{ s.text }}
        </option>
      </select>
    </div>
    <div class="select-container">
      <span class="select-title">Estatus de la cita</span>
      <select @change="handleSelect" class="select">
        <option
          v-for="(s, i) in select"
          :key="i"
          :value="s.value"
          :selected="s.selected"
          :disabled="s.disabled"
        >
          {{ s.text }}
        </option>
      </select>
    </div>
    <div class="btn-reload-container">
      <button class="btn-reload" @click="handleReload">Actualizar</button>
    </div>

    <Modal
      @closeModal="closeModal"
      :fit="true"
      :linea="false"
      :showHeader="false"
      v-if="showModal"
    >
      <!-- <div class="header-title">
        <h3 class="modal-header" > Personalizar</h3>
    </div> -->
      <div class="header-container">
        <span class="modal-header">{{ getHeaderDate }} </span>
        <span class="modal-header"> - </span>
        <span class="modal-header"> {{ getHeaderDateEnd }} </span>
      </div>
      <v-date-picker v-model="date" range no-title scrollable> </v-date-picker>
      <div class="btn-container">
        <button class="btn-cancelar" @click="closeModal">Cancelar</button>
        <button
          class="btn-aplicar"
          @click="changeDate"
          :disabled="handleDateDisabled"
        >
          Aceptar
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
import Modal from "../Modales/Modal.vue";
moment.locale("es");
export default {
  emits: ["dates", "status", "busqueda"],
  components: { Modal },
  data() {
    return {
      select: [
        { value: "0", text: "Pendiente", disabled: false, selected: false },
        { value: "1", text: "Asistió", disabled: false, selected: false },
        { value: "2", text: "No asistió", disabled: false, selected: false },
        {
          value: "3",
          text: "Cancelar",
          disabled: false,
          selected: false,
        },
        {
          value: "4",
          text: "Todos",
          disabled: false,
          selected: true,
        },
      ],
      dateSelect: [
        {
          value: "0",
          text: "Selecciona una opción",
          disabled: true,
          selected: false,
        },
        { value: "1", text: "Dia", disabled: false, selected: false },
        { value: "2", text: "Mes", disabled: false, selected: true },
        { value: "3", text: "Año", disabled: false, selected: false },
        { value: "4", text: "Personalizar", disabled: false, selected: false },
      ],
      date: [],
      fechaInicio: "",
      fechaFin: "",
      busqueda: "",
      showModal: false,
    };
  },
  computed: {
    handleDateDisabled() {
      if (this.date.length > 0) return false;
      return true;
    },
    getHeaderDate() {
      return this.date.length > 0
        ? moment(this.date[0]).format("DD MMMM YYYY")
        : moment().format("DD MMMM YYYY");
    },
    getHeaderDateEnd() {
      return this.date.length > 1
        ? moment(this.date[1]).format("DD MMMM YYYY")
        : this.getHeaderDate;
    },
  },

  methods: {
    handleReload() {
      window.location.reload();
    },
    searchClient() {
      this.$emit("busqueda", this.busqueda);
    },
    handleSelect(e) {
     switch (e.target.value) {
      case "0":
      this.$emit("status", 1);
        break;
        case "1":
      this.$emit("status", 3);
      break;
      case "2":
      this.$emit("status", 2);
      break;
      case "3":
      this.$emit("status", 0);
      break;
      case "4":
      this.$emit("status", 4);
      break;
      default:
      this.$emit("status", 4);
        break;
     }
    },
    closeModal() {
      this.showModal = false;
    },
    changeDate() {
      let [f1, f2] = this.date;
      if (!f2) f2 = f1;
      if (f2 > f1) {
        f1 = moment(f1).startOf("day").format("DD-MM-YYYY");
        f2 = moment(f2).endOf("day").format("DD-MM-YYYY");
        this.fechaInicio = f1;
        this.fechaFin = f2;
      } else {
        f2 = moment(f2).startOf("day").format("DD-MM-YYYY");
        f1 = moment(f1).endOf("day").format("DD-MM-YYYY");
        this.fechaFin = f1;
        this.fechaInicio = f2;
      }
      this.emitDates();
      this.showModal = false;
    },
    emitDates() {
      const dates = {
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
      };
      this.$emit("dates", dates);
    },
    handleDateSelect(e) {
      switch (e.target.value) {
        case "0":
          break;
        case "1":
          (this.fechaInicio = moment()
            .startOf("day")
            .format("DD-MM-YYYY")),
            (this.fechaFin = moment().format("DD-MM-YYYY"));
          this.emitDates();
          break;
        case "2":
          (this.fechaInicio = moment()
            .startOf("month")
            .format("DD-MM-YYYY")),
            (this.fechaFin = moment()
              .utc()
              .endOf("month")
              .format("DD-MM-YYYY"));
          this.emitDates();
          break;
        case "3":
          (this.fechaInicio = moment()
            .startOf("year")
            .format("DD-MM-YYYY")),
            (this.fechaFin = moment()
              .utc()
              .endOf("year")
              .format("DD-MM-YYYY"));
          this.emitDates();
          break;
        case "4":
          e.target.value = "0";
          this.showModal = true;
          break;
        default:
          (this.fechaInicio = moment()
            .startOf("month")
            .format("DD-MM-YYYY")),
            (this.fechaFin = moment()
              .endOf("month")
              .format("DD-MM-YYYY"));
          break;
      }
    },
  },
  // watch: {
  //   fechaFin() {
  //     const dates = {
  //       fechaInicio: this.fechaInicio,
  //       fechaFin: this.fechaFin,
  //     };
  //     this.$emit("dates", dates);
  //   },
  // },
};
</script>

<style scoped>
.filtro-container {
  display: grid;
  width: 100%;
  align-items: center;
  grid-template-columns: 30% 20% 20% 26%;
  column-gap: 15px;
  grid-template-rows: 1fr;
  margin-bottom: 25px;
}

.header-container {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
/* .header-title{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
} */

.btn-reload-container {
  display: flex;
  justify-self: flex-end;
}
.modal-header {
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0px;
  color: #707070;
}
.input {
  width: 100%;
  border-bottom: 1px solid #000;
  padding-left: 25px;
  background-image: url("../../assets/imgs/Buscar.svg");
  background-size: 17px;
  background-position-y: center;
  outline: none;
}
.select-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.select-title {
  min-width: fit-content;
  font: normal normal normal 14px/22px Open Sans;
  color: #616161;
  margin: 0;
  padding: 0;
}
.btn-container {
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  padding: 0 10px 0 10px;
}

.btn-aplicar {
  width: 80px;
  height: 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: none;
  border-radius: 4px;
  color: #0a4f9c;
}
.btn-cancelar {
  width: 80px;
  height: 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: none;
  border-radius: 4px;
  color: #93c6ff;
}
/* .btn:hover {
  border: 1px solid #fff;
  background-color: #4873d3;
  color: #fff;
} */
.btn-cancelar:disabled,
.btn-aplicar:disabled {
  opacity: 0.5;
  cursor: no-drop;
}

.btn-reload {
  color: #fff;
  width: 140px;
  height: 35px;
  background-image: url("../../assets/imgs/icons/actualizar.svg");
  background-size: 17px;
  background-position-x: 13px;
  background-position-y: center;
  background-color: #0a4f9c;
  border-radius: 4px;
  padding-left: 10px;
}
.btn-reload:hover {
  background-color: #012a56;
}
.select {
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  height: 35px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #616161;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #afafaf;
  border-radius: 4px;
  padding-left: 10px;
  cursor: pointer;
  outline: none;
}
.select:hover {
  background: #f3f3f3 0% 0% no-repeat padding-box;
}
.margin {
  margin-left: 7px;
}

@media screen and (max-width: 1279px) {
  .filtro-container {
    display: grid;
    grid-template-columns: 49% 49%;
    grid-template-rows: 1fr 1fr;
    row-gap: 20px;
    align-content: center;
    justify-items: flex-end;
  }

  .select-title {
    font: normal normal bold 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #616161;
  }

  .select{
    min-width: 142px;
    margin-left: 20px;
  }

  .btn-reload-container {
    grid-column: 2/3;
    grid-row: 1/2;
  }
}

@media screen and (max-width: 767px) {
  .select {
    font-size: 11px;
  }
  .btn-container {
    display: flex;
    justify-content: space-between;
    padding: 0 10px 10px 10px;
  }

  .filtro-container {
    display: grid;
    grid-template-columns: 60% 36%;
    grid-template-rows: 1fr 1fr;
    row-gap: 20px;
    align-content: center;
  }

  .btn-reload{
    width: 120px;
    background-position-x: 5px;
  }

  .select-title {
    font: normal normal bold 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #616161;
  }

  .select-container{
    font: normal normal normal 16px/22px Open Sans;
    width: 100%;
    grid-column: span 2;
    display: flex;
    justify-content: space-between;
  }

  .select{

    max-width: 200px;
    margin-left: 20px;
  }

  .btn-reload-container {
    grid-column: 2/3;
    grid-row: 1/2;
  }
}
</style>
